import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { v4 as uuidv4 } from "uuid";

export const useChatStore = create(
  devtools(
    persist(
      (set, get) => ({
        proposalId: null, // Start with null

        resetProposalId: () => set({ proposalId: uuidv4() }),
      }),
      {
        name: "chat-storage", // localStorage key
      }
    ),
    {
      name: "Chat-storage", // For Redux DevTools
      enabled: process.env.NODE_ENV === "development",
    }
  )
);
